import {ReactElement} from "react";
import {BORDER_RADIUS_LARGE, PD_XLG} from "@/shared/dimens";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {LargeButton, SectionContainer} from "./SharedComponents";
import {useMediaQuery, useTheme} from "@mui/material";
import {HeroSectionData} from "../../types";

export function HeroSection(props: { data: HeroSectionData }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  return <SectionContainer>
    <div style={{
      width: "100%",
      position: "relative",
      aspectRatio: md ? 2 : (sm ? 3 / 2 : 3 / 4),
      overflow: "hidden",
      borderRadius: BORDER_RADIUS_LARGE,
    }}>
      <img src={props.data.imageUrl}
           style={{
             position: "absolute",
             width: "100%",
             height: "100%",
             top: 0,
             left: 0,
             objectFit: "cover",
             objectPosition: "right 20% top 0%",
           }}/>
      <div style={{
        background: "linear-gradient(transparent, #000)",
        width: "100%",
        height: "100%",
        opacity: 0.8,
        position: "absolute",
        bottom: 0
      }}/>
      <StyledBoxColumn
        style={{
          padding: "4%",
          position: "absolute",
          width: md ? "50%" : "100%",
          gap: PD_XLG,
          alignItems: "start",
          bottom: 0
        }}>
        <StyledHeadingVariant default_={2} style={{color: "white"}}>
          {props.data.title}
        </StyledHeadingVariant>
        <StyledBoxRow>
          {props.data.primaryLink?.text
            ? <LargeButton
              href={props.data.primaryLink.url}
              variant={"contained"}>
              {props.data.primaryLink.text}
            </LargeButton>
            : null}
          {props.data.secondaryLink?.text
            ? <LargeButton
              href={props.data.secondaryLink.url}
              variant={"contained"}
              color={"secondary"}>
              {props.data.secondaryLink.text}
            </LargeButton>
            : null}
        </StyledBoxRow>
      </StyledBoxColumn>
    </div>
  </SectionContainer>;
}